<template>
    <div id="app">
		<!-- 首页导航锚点定位 单独因为的header-->
		<Header v-if="!$route.meta.hideHeader" @getlocal='getlocal'></Header>
		<router-view/>
		<Footer v-show="!$route.meta.hideHeader"></Footer>
    </div>
</template>
<script>
import Header from './components/header.vue'
import Footer from './components/footer.vue'
import Cookies from 'js-cookie'
export default{
	components: { Header,Footer  },
	name:'App',
	mounted(){
		console.log('===')
	},
	created() {
    	//创建时执行跳转锚点位置。
		this.$nextTick(() => { 
			if(this.$route.name=='login') return
			this.getlocal(); 
		}); 
	},
	methods:{
		getlocal() {  
			const selectId = localStorage.getItem('toId') || Cookies.get('toId');
			if (!selectId) return;
			const toElement = document.getElementById(selectId);
			if (toElement) {
				toElement.scrollIntoView(true);
			}
		},
	}
 }
</script>

<style scoped>
  
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
